// public/renderer.js

// Core boot imports. Everything else is loaded on demand below to keep the
// initial bundle as small as possible.
import './js/modules/sessionLog.js';
import { initializeApp } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-app.js';
import { initializeAppCheck, ReCaptchaV3Provider, CustomProvider } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-app-check.js';
import { getAuth } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-auth.js';
import { firebaseConfig } from './js/modules/firebaseConfig.js';
import { checkLoginStatusAndDisplayUI, signInWithGoogle, signInWithFacebook, signInWithApple, signInWithEmail, signUpWithEmail, signOutUser, handleEmailAction, enterGuestMode } from './js/modules/auth.js';
import { initPushNotifications } from './js/modules/pushNotifications.js';
import { getUserProfile, getUserSession, getSongById, getCurrentLiveShow } from './js/modules/firestore/firestoreService.js';
import { setActiveChannel, initializeTitleBannerCollapse } from './js/modules/navigation.js';
import { getOptimizedImageUrl, preloadImage } from './js/modules/utils.js';
import { syncClock } from './js/modules/timeSync.js';
import { isConnected } from './js/modules/playerControlState.js';
import { log } from './js/modules/logger.js';
import { loadAndApplyTheme } from './js/modules/ui/themeManager.js';
import { useAppStore } from './js/modules/store.js';
import './js/modules/toastNotifications.js';


window.handleGuestLogin = () => {
    enterGuestMode();
};



window.handleShowSignup = () => {

    const guestData = {
        coins: useAppStore.getState().coins || 0,
        tickets: useAppStore.getState().tickets || 0,
        badges: JSON.parse(sessionStorage.getItem('guestBadges') || '[]'),
        playlists: JSON.parse(sessionStorage.getItem('guestPlaylists') || '[]'),
        preferredGenre: sessionStorage.getItem('guestPreferredGenre') || null,
        aiPersonality: sessionStorage.getItem('guestAiPersonality') || 'default',
        timestamp: Date.now()
    };


    localStorage.setItem('pendingGuestTransfer', JSON.stringify(guestData));
    localStorage.setItem('guestTransferOrigin', window.location.href);


    window.location.href = 'https://octave11.com?signup=1&from=guest';
};

const googleLoginBtn = document.getElementById('google-login-btn');


window.activeScrollArea = null;

function setupScrollAreaKeyboardNavigation() {
    
    const scrollAreas = {
        'carousel': ['carousel-arrow-left', 'carousel-arrow-right', 'record-carousel-container'],
        'account-banners': ['account-banner-prev', 'account-banner-next', 'account-stock-banner-container'],
        'account-backgrounds': ['account-background-prev', 'account-background-next', 'account-stock-background-container'],
        'dm-icons': ['dm-scroll-left', 'dm-scroll-right', 'dm-icons-carousel']
    };

    
    Object.entries(scrollAreas).forEach(([area, selectors]) => {
        selectors.forEach(selector => {
            const el = document.getElementById(selector);
            if (el) {
                el.addEventListener('click', () => {
                    window.activeScrollArea = area;
                });
            }
        });
    });

    
    document.addEventListener('keydown', (e) => {
        
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

        const area = window.activeScrollArea;
        if (!area) return;

        if (area === 'dm-icons') {
            
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                scrollDMs(-1);
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                scrollDMs(1);
            }
        } else {
            
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                handleHorizontalScroll(area, -1);
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                handleHorizontalScroll(area, 1);
            }
        }
    });
}

async function handleHorizontalScroll(area, direction) {
    if (area === 'carousel') {
        
        const btn = direction < 0 ? 
            document.getElementById('carousel-arrow-left') : 
            document.getElementById('carousel-arrow-right');
        if (btn) btn.click();
    } else if (area === 'account-banners') {
        
        const btn = direction < 0 ? 
            document.getElementById('account-banner-prev') : 
            document.getElementById('account-banner-next');
        if (btn && !btn.disabled) btn.click();
    } else if (area === 'account-backgrounds') {
        
        const btn = direction < 0 ? 
            document.getElementById('account-background-prev') : 
            document.getElementById('account-background-next');
        if (btn && !btn.disabled) btn.click();
    }
}


function scrollDMs(direction) {
    
}

async function handleNotificationUrlParam() {
  const params = new URLSearchParams(window.location.search);
  const notif = params.get('notif');
  if (!notif) return;

  const cid = params.get('cid');
  if (notif === 'dm' || cid) {
    if (cid) window._pendingDmContactId = cid;
    setActiveChannel('mail').catch(e => console.warn('[Renderer] Failed to switch to mail:', e));
  } else if (notif === 'live') {
    setActiveChannel('sonic-lounge').catch(e => console.warn('[Renderer] Failed to switch to live:', e));
  } else if (['mentions', 'comments', 'likes', 'coins'].includes(notif)) {
    const { handleNotificationsClick } = await import('./js/modules/notificationsManager.js');
    handleNotificationsClick();
  }

  // Clean the query parameters so reloading does not re-trigger navigation
  try {
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('notif');
    cleanUrl.searchParams.delete('cid');
    cleanUrl.searchParams.delete('showId');
    window.history.replaceState({}, '', cleanUrl);
  } catch (e) {
    console.warn('[Renderer] Could not clean notification URL params:', e);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const app = initializeApp(firebaseConfig);
  
  // Replace this with the new reCAPTCHA v3 site key after regenerating the key pair
  // in the Google reCAPTCHA admin console and updating the secret in Firebase App Check.
  const RECAPTCHA_V3_SITE_KEY = '6Le7ZlstAAAAAAJhpkPsQ3PE6goXOia2vW67bmim';

  const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const debugToken = isLocalhost
    ? (window.FIREBASE_APPCHECK_DEBUG_TOKEN || localStorage.getItem('firebase_app_check_debug_token'))
    : null;

  let appCheckProvider;
  if (isLocalhost && debugToken) {
    log('[AppCheck] Using CustomProvider with localhost debug token');
    appCheckProvider = new CustomProvider({
      getToken: () => Promise.resolve({
        token: debugToken,
        expireTimeMillis: Date.now() + 86400000
      })
    });
  } else {
    appCheckProvider = new ReCaptchaV3Provider(RECAPTCHA_V3_SITE_KEY);
  }

  initializeAppCheck(app, {
    provider: appCheckProvider,
    isTokenAutoRefreshEnabled: true
  });
  
  const auth = getAuth(app);

  handleEmailAction(auth);

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then(reg => console.log('[SW] Registered:', reg.scope))
      .catch(err => console.warn('[SW] Registration failed:', err));
  }

  
  import('./js/modules/ui/luminanceUtils.js').then(module => {
    module.updateVolumeTooltipContrast();
  });

  if (googleLoginBtn) {
    googleLoginBtn.addEventListener('click', () => signInWithGoogle(auth));
  }

  
  const facebookLoginBtn = document.getElementById('facebook-login-btn');
  const appleLoginBtn = document.getElementById('apple-login-btn');
  const emailLoginBtn = document.getElementById('email-login-btn');
  const emailModal = document.getElementById('email-modal');
  const modalCancelBtn = document.getElementById('modal-cancel-btn');
  const modalSubmitBtn = document.getElementById('modal-submit-btn');

  if (facebookLoginBtn) {
    facebookLoginBtn.addEventListener('click', () => signInWithFacebook(auth));
  }

  if (appleLoginBtn) {
    appleLoginBtn.addEventListener('click', () => signInWithApple(auth));
  }

  
  if (emailLoginBtn) {
    emailLoginBtn.addEventListener('click', () => {
      emailModal.style.display = 'flex';
      document.getElementById('modal-email').value = '';
      document.getElementById('modal-password').value = '';
      document.getElementById('email-error-msg').classList.add('hidden');
      
      setAuthMode('signin');
      document.getElementById('modal-email').focus();
    });
  }

  
  let currentAuthMode = 'signin';
  const toggleSignIn = document.getElementById('toggle-signin');
  const toggleSignUp = document.getElementById('toggle-signup');

  function setAuthMode(mode) {
    currentAuthMode = mode;
    if (mode === 'signin') {
      toggleSignIn.classList.add('active');
      toggleSignUp.classList.remove('active');
      modalSubmitBtn.textContent = 'Sign In';
      document.querySelector('.modal-title').textContent = 'Sign in with Email';
    } else {
      toggleSignIn.classList.remove('active');
      toggleSignUp.classList.add('active');
      modalSubmitBtn.textContent = 'Sign Up';
      document.querySelector('.modal-title').textContent = 'Sign up with Email';
    }
    
    document.getElementById('email-error-msg').classList.add('hidden');
  }

  if (toggleSignIn) {
    toggleSignIn.addEventListener('click', () => setAuthMode('signin'));
  }
  if (toggleSignUp) {
    toggleSignUp.addEventListener('click', () => setAuthMode('signup'));
  }

  
  if (modalCancelBtn) {
    modalCancelBtn.addEventListener('click', () => {
      emailModal.style.display = 'none';
    });
  }

  
  if (emailModal) {
    emailModal.addEventListener('click', (e) => {
      if (e.target === emailModal) {
        emailModal.style.display = 'none';
      }
    });
  }

  
  if (modalSubmitBtn) {
    modalSubmitBtn.addEventListener('click', async () => {
      const email = document.getElementById('modal-email').value;
      const password = document.getElementById('modal-password').value;
      const errorMsg = document.getElementById('email-error-msg');

      if (!email || !password) {
        errorMsg.textContent = 'Please enter both email and password.';
        errorMsg.classList.remove('hidden');
        return;
      }

      if (password.length < 6) {
        errorMsg.textContent = 'Password must be at least 6 characters.';
        errorMsg.classList.remove('hidden');
        return;
      }

      try {
        errorMsg.classList.add('hidden');
        
        if (currentAuthMode === 'signup') {
          
          await signUpWithEmail(auth, email, password);
        } else {
          
          await signInWithEmail(auth, email, password);
        }
        emailModal.style.display = 'none';
        
        
        if (document.body.classList.contains('guest-mode')) {
          sessionStorage.setItem('guest_just_signed_up', 'true');
          window.location.reload();
        }
      } catch (error) {
        if (currentAuthMode === 'signin') {
          
          if (error.code === 'auth/user-not-found' || error.code === 'auth/invalid-credential') {
            errorMsg.textContent = 'No account found with this email. Try signing up!';
            errorMsg.classList.remove('hidden');
          } else if (error.code === 'auth/wrong-password') {
            errorMsg.textContent = 'Incorrect password.';
            errorMsg.classList.remove('hidden');
          } else if (error.code === 'auth/invalid-email') {
            errorMsg.textContent = 'Invalid email address.';
            errorMsg.classList.remove('hidden');
          } else {
            errorMsg.textContent = 'Sign in failed. Please try again.';
            errorMsg.classList.remove('hidden');
          }
        } else {
          
          let message = 'Account creation failed.';
          if (error.code === 'auth/email-already-in-use') {
            message = 'An account with this email already exists. Try signing in!';
          } else if (error.code === 'auth/weak-password') {
            message = 'Password is too weak.';
          } else if (error.code === 'auth/invalid-email') {
            message = 'Invalid email address.';
          }
          errorMsg.textContent = message;
          errorMsg.classList.remove('hidden');
        }
      }
    });
  }

  
  let siteRefreshUnsubscribe = null;
  async function initSiteRefreshListener() {
      if (siteRefreshUnsubscribe) return;
      try {
          const { getFirestore, doc, onSnapshot } = await import('https://www.gstatic.com/firebasejs/9.23.0/firebase-firestore.js');
          const db = getFirestore();
          const siteStateRef = doc(db, 'siteState', 'global');
          siteRefreshUnsubscribe = onSnapshot(siteStateRef, (docSnap) => {
              if (docSnap.exists() && docSnap.data().needsRefresh === true) {
                  console.log('[SiteRefresh] Refresh command received, clearing flag and reloading...');
                  
                  fetch('https://us-east1-f8lyss-music-app-63fb7.cloudfunctions.net/clearRefreshFlag', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' }
                  }).catch(e => console.warn('[SiteRefresh] Failed to clear flag:', e));
                  setTimeout(() => location.reload(), 100);
              }
          });
      } catch (e) {
          console.warn('[SiteRefresh] Failed to initialize listener:', e);
      }
  }

  checkLoginStatusAndDisplayUI(auth, async (user, userProfile) => {
    try {
      const sharedSongId = new URLSearchParams(window.location.search).get('song');
      if (sharedSongId) {
        window._sharedSongId = sharedSongId;
        window._loadingSharedSong = true;
      }

      await syncClock();
      initializeNavigation(auth);
      
      
      initSiteRefreshListener();
      
      if (userProfile) {
          await loadAndApplyTheme(userProfile);
      }

      // Load non-core UI managers in parallel so they don't bloat the main chunk.
      const [
        { initializeUserStatus },
        { initializeSocialsWidget },
        { initializeHeaderPointsManager },
        { initializeAICoPilot },
        { initializeShowListener },
        { initializeChatConsole, switchMode: switchChatMode },
        { initializeConsoleTabs },
        { initializeSonicLounge },
        { initializeChatBanner },
      ] = await Promise.all([
        import('./js/components/userStatusManager.js'),
        import('./js/components/socialsWidget.js'),
        import('./js/components/headerPointsManager.js'),
        import('./js/components/aiCoPilot.js'),
        import('./js/components/sonic_lounge/showListener.js'),
        import('./js/components/chatConsoleManager.js'),
        import('./js/components/consoleManager.js'),
        import('./js/components/sonic_lounge/sonicLoungeManager.js'),
        import('./js/components/chatBannerManager.js'),
      ]);

      initializeUserStatus(userProfile);
      initializeSocialsWidget();
      initializeHeaderPointsManager();
      
      
      if (user) {
        const { setCurrentUserId, startListenTracking } = await import('./js/modules/listenTimeTracker.js');
        setCurrentUserId(user.uid);
        startListenTracking(user.uid);
      }
      
      initializeAICoPilot();
      
      
      initializeShowListener();
      
      
      const isGuest = useAppStore.getState().isGuest;
      if (isGuest) {
        const headerProfilePic = document.getElementById('header-profile-pic');
        if (headerProfilePic) {
          headerProfilePic.style.display = 'none';
        }
      }
      
      const { initializeAnimations } = await import('./js/components/animationManager.js');
      initializeAnimations();
      await initializeChatConsole();
      window.switchChatMode = switchChatMode;
      initializeConsoleTabs();
      
      
      
      initializeSonicLounge();
      
      initializeChatBanner();
      initPushNotifications();
      
      import('./js/components/ticketModalManager.js').then(({ initializeTicketPanelManager }) => {
        initializeTicketPanelManager();
      });
      
      
      initializeTitleBannerCollapse();

      
      setupScrollAreaKeyboardNavigation();
      
      
      
      
      
      const loadDeferredModules = async () => {
        try {
          const [helpMode, searchMode, commentModal] = await Promise.all([
            import('./js/components/helpModeManager.js'),
            import('./js/components/searchModeManager.js'),
            import('./js/components/commentModalManager.js')
          ]);

          
          await searchMode.initializeSearchMode();

          
          const helpModeBtn = document.getElementById('help-mode-btn');
          if (helpModeBtn) {
            helpModeBtn.addEventListener('click', helpMode.handleHelpModeToggle);
          }
          
          
          const artistBtn = document.getElementById('artist-playlist-btn');
          if (artistBtn) {
            artistBtn.addEventListener('click', (e) => helpMode.handleHelpModeARPClick('artist-playlist-btn', e));
          }
          
          
          const randomBtn = document.getElementById('random-playlist-btn');
          if (randomBtn) {
            randomBtn.addEventListener('click', (e) => helpMode.handleHelpModeARPClick('random-playlist-btn', e));
          }
          
          
          const copilotInput = document.getElementById('copilot-input');
          if (copilotInput) {
            copilotInput.addEventListener('click', (e) => helpMode.handleHelpModeInputClick(e));
          }
          
          const copilotSendBtn = document.getElementById('copilot-send-btn');
          if (copilotSendBtn) {
            copilotSendBtn.addEventListener('click', (e) => helpMode.handleHelpModeSendClick(e));
          }
          
          const jukebotInfoBtn = document.getElementById('jukebot-info-btn');
          if (jukebotInfoBtn) {
            jukebotInfoBtn.addEventListener('click', (e) => helpMode.handleHelpModeJukebotInfoClick(e));
          }
          
          
          const coinsBtn = document.getElementById('header-points-btn');
          if (coinsBtn) {
            coinsBtn.addEventListener('click', (e) => helpMode.handleHelpModeCoinsClick(e));
          }
          
          const ticketsBtn = document.getElementById('header-ticket-btn');
          if (ticketsBtn) {
            ticketsBtn.addEventListener('click', (e) => helpMode.handleHelpModeTicketsClick(e));
          }
          
          
          document.addEventListener('click', (e) => {
            const activeSongTile = e.target.closest('.record-item.featured');
            if (activeSongTile) {
                helpMode.handleHelpModeActiveSongClick(e);
                return;
            }
            const previousSongTile = e.target.closest('.record-item.slot--1');
            if (previousSongTile) {
                helpMode.handleHelpModePreviousSongClick(e);
                return;
            }
            const followingSongTile = e.target.closest('.record-item.slot-1');
            if (followingSongTile) {
                helpMode.handleHelpModeFollowingSongClick(e);
                return;
            }
            const navItem = e.target.closest('.nav-item');
            if (navItem) {
                helpMode.handleHelpModeNavClick(e);
                return;
            }
            
            const playsCounter = e.target.closest('#plays-counter-slot-machine');
            if (playsCounter) {
                helpMode.handleHelpModePlaysCounterClick(e);
                return;
            }
          });
          
          
          window.handleHelpModeActiveSongClick = helpMode.handleHelpModeActiveSongClick;
          window.handleHelpModePreviousSongClick = helpMode.handleHelpModePreviousSongClick;
          window.handleHelpModeFollowingSongClick = helpMode.handleHelpModeFollowingSongClick;
          window.handleHelpModeNavClick = helpMode.handleHelpModeNavClick;
          window.handleHelpModeInputClick = helpMode.handleHelpModeInputClick;
          window.handleHelpModeSendClick = helpMode.handleHelpModeSendClick;
          window.handleHelpModeJukebotInfoClick = helpMode.handleHelpModeJukebotInfoClick;
          window.handleHelpModeCoinsClick = helpMode.handleHelpModeCoinsClick;
          window.handleHelpModeTicketsClick = helpMode.handleHelpModeTicketsClick;
          window.handleHelpModeClearChatClick = helpMode.handleHelpModeClearChatClick;
          window.handleHelpModeNotificationsClick = helpMode.handleHelpModeNotificationsClick;
          window.handleHelpModeSuggestionsClick = helpMode.handleHelpModeSuggestionsClick;
          window.handleHelpModeBadgeModeClick = helpMode.handleHelpModeBadgeModeClick;
          window.handleHelpModeLikeClick = helpMode.handleHelpModeLikeClick;
          window.handleHelpModeAddToPlaylistClick = helpMode.handleHelpModeAddToPlaylistClick;
          window.handleHelpModeWaveformClick = helpMode.handleHelpModeWaveformClick;
          window.handleHelpModeVolumeClick = helpMode.handleHelpModeVolumeClick;
          window.handleHelpModePlaysCounterClick = helpMode.handleHelpModePlaysCounterClick;
          window.handleHelpModeArtistChatClick = helpMode.handleHelpModeArtistChatClick;
          window.handleHelpModeAddContactClick = helpMode.handleHelpModeAddContactClick;

          
          commentModal.setupCommentModalEventListeners();
          
          
          if (user) {
            await import('./js/components/adminChannelManager.js');
          }
        } catch (error) {
          console.error('[Deferred Load] Error loading deferred modules:', error);
        }
      };

      
      if (typeof requestIdleCallback !== 'undefined') {
        requestIdleCallback(() => loadDeferredModules(), { timeout: 2000 });
      } else {
        setTimeout(() => loadDeferredModules(), 0);
      }
      const [
        { setupMusicPlayerControls },
        { updateMusicPlayerUI },
        { loadPlaylistPreferences, rebuildPlaylistFromCurrentModes, setupPlaylistControls: setupARPControls, currentPlaylist, getRandomSiteArtistSong, setPlaylistMode }
      ] = await Promise.all([
        import('./js/components/musicPlayerControls.js'),
        import('./js/components/playerVisuals.js'),
        import('./js/components/playlistManager.js'),
      ]);
      await setupMusicPlayerControls();
      setupARPControls();
      await loadPlaylistPreferences();
      
      async function updateLotteryVisibility() {
        const ticketBtn = document.getElementById('console-lottery-ticket-btn');
        if (!ticketBtn) return;

        const liveShow = await getCurrentLiveShow();
        const isLotteryShow = liveShow && (liveShow.type === 'lottery' || liveShow.type === 'themed');
        
        ticketBtn.style.display = isLotteryShow ? 'inline-block' : 'none';
        
        const hasWonLast = localStorage.getItem('lastLotteryWinner') === getAuth().currentUser?.uid;
        if (hasWonLast) {
            ticketBtn.title = "1-turn cooldown";
            ticketBtn.style.opacity = '0.5';
            ticketBtn.style.pointerEvents = 'none';
        } else {
            ticketBtn.title = "Enter Ticket";
            ticketBtn.style.opacity = '1';
            ticketBtn.style.pointerEvents = 'auto';
        }
      }

      setInterval(updateLotteryVisibility, 10000);
      
      const liveShow = await getCurrentLiveShow();
      const manuallyDisconnectedShowId = sessionStorage.getItem('manuallyDisconnectedShowId');
      
      await setActiveChannel('sonic-lounge');
      
      
      if (user && !window._loadingSharedSong && !window._sharedSongLoaded) {
        const session = await getUserSession(user.uid);
        const profile = !session ? userProfile : null;
        const resumeSongId = session?.lastPlayedSongId ?? profile?.lastPlayedSongId;
        if (resumeSongId) {
            const songData = await getSongById(resumeSongId);
            if (songData) {
                if (songData.albumArtUrl) {
                    preloadImage(getOptimizedImageUrl(songData.albumArtUrl, 1200, 1200)).catch(() => {});
                }
                await updateMusicPlayerUI(songData);
            }
        }
      }
      
      await rebuildPlaylistFromCurrentModes();
      
      
      const currentSongId = useAppStore.getState().currentLoadedSongId;
      console.log('[Renderer] startup decision block', {
        currentSongId,
        currentPlaylistLength: currentPlaylist.length,
        source: 'renderer.js'
      });
      if ((!currentSongId || currentPlaylist.length === 0) && !window._loadingSharedSong) {
        log.info("Play queue empty after login - loading random song for guest/user");
        
        
        const isGuest = useAppStore.getState().isGuest;
        if (isGuest || !user) {
          await setPlaylistMode('RANDOM');
        }
        
        
        const startSong = await getRandomSiteArtistSong();
        console.log('[Renderer] fallback random startSong', { id: startSong?.id, title: startSong?.title });
        if (startSong) {
          if (startSong.albumArtUrl) {
              preloadImage(getOptimizedImageUrl(startSong.albumArtUrl, 1200, 1200)).catch(() => {});
          }
          await updateMusicPlayerUI(startSong, { shouldPlay: false });
          log.info("Loaded random song for initial playlist: " + startSong.title);
        }
      }
      
    } catch (error) {
      log.error('An error occurred during app initialization:', error);
    } 
  });
});


window.initializeGuestApp = async function() {
  console.log('[Renderer] Initializing guest app components...');

  const [
    { initializeChatConsole, switchMode: switchChatMode },
    { initializeConsoleTabs },
    { initializeChatBanner },
    { initializeSocialsWidget },
    { initializeUserStatus },
    { initializeHeaderPointsManager },
    { initializeShowListener },
    { initializeSonicLounge },
  ] = await Promise.all([
    import('./js/components/chatConsoleManager.js'),
    import('./js/components/consoleManager.js'),
    import('./js/components/chatBannerManager.js'),
    import('./js/components/socialsWidget.js'),
    import('./js/components/userStatusManager.js'),
    import('./js/components/headerPointsManager.js'),
    import('./js/components/sonic_lounge/showListener.js'),
    import('./js/components/sonic_lounge/sonicLoungeManager.js'),
  ]);

  initializeNavigation(null);
  
  
  await setActiveChannel('sonic-lounge');
  
  
  const [{ setupMusicPlayerControls }, { setupPlaylistControls: setupARPControls }, { initPushNotifications }, { initializeAnimations }] = await Promise.all([
    import('./js/components/musicPlayerControls.js'),
    import('./js/components/playlistManager.js'),
    import('./js/modules/pushNotifications.js'),
    import('./js/components/animationManager.js'),
  ]);
  await setupMusicPlayerControls();
  
  
  await initializeChatConsole();
  window.switchChatMode = switchChatMode;
  
  
  initializeConsoleTabs();
  
  
  initializeChatBanner();
  
  
  initializeTitleBannerCollapse();

  
  const { initNotificationsManager } = await import('./js/modules/notificationsManager.js');
  initNotificationsManager();
  initPushNotifications();

  
  initializeAnimations();
  
  
  initializeHeaderPointsManager();
  
  
  const { initializeHelpModeEventListeners } = await import('./js/components/helpModeManager.js');
  initializeHelpModeEventListeners();

  const { initializeHelpGlossary } = await import('./js/components/helpGlossaryManager.js');
  initializeHelpGlossary();
  
  
  const { initializeSearchMode } = await import('./js/components/searchModeManager.js');
  initializeSearchMode();
  
  
  initializeSocialsWidget();
  
  
  initializeUserStatus(null);
  
  
  setupARPControls();
  
  
  const { setupCommentModalEventListeners } = await import('./js/components/commentModalManager.js');
  setupCommentModalEventListeners();
  
  
  const headerProfilePic = document.getElementById('header-profile-pic');
  if (headerProfilePic) {
    headerProfilePic.style.display = 'none';
  }
  
  
  initializeShowListener();


  initializeSonicLounge();

  await handleNotificationUrlParam();

  console.log('[Renderer] Guest app components initialized');
};

function initializeNavigation(auth) {
  const navItems = document.querySelectorAll('.nav-item');
  const logoutBtn = document.getElementById('logout-btn');

  if(logoutBtn) {
    logoutBtn.addEventListener('click', () => signOutUser(auth));
  }
  
  navItems.forEach((item) => {
    item.addEventListener('click', async (e) => {
      
      const helpModeBtn = document.getElementById('help-mode-btn');
      if (helpModeBtn && helpModeBtn.classList.contains('active')) {
        
        return;
      }
      
      const channelToSwitchTo = item.dataset.channel;
      log.info('Nav item clicked: ' + channelToSwitchTo);
      
      await setActiveChannel(channelToSwitchTo);
    });

    item.addEventListener('mouseenter', () => {
        const icon = item.querySelector('i');
        if (icon) {
            icon.classList.add('electrify-scramble', 'electrify-jitter');
            setTimeout(() => {
                icon.classList.remove('electrify-jitter');
            }, 300); 
        }
    });

    item.addEventListener('mouseleave', () => {
        const icon = item.querySelector('i');
        if (icon) {
            icon.classList.remove('electrify-scramble', 'electrify-jitter');
        }
    });
  });
}
